import { ENV } from "../utils";

export class Form {
  baseApi = ENV.BASE_API;

  async getForm(accessToken, idForm) {
    try {
      const url = `${this.baseApi}/form/${idForm}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async createForm(accessToken, data) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
      const url = `${this.baseApi}/add-form`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);

      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getForms(accessToken, name, active = undefined) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const url = `${this.baseApi}/forms/${name}?active=${active}`;
      const params = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateForm(accessToken, idForm, formData) {
    try {
      const data = formData;
      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });

      // const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${ENV.BASE_API}/update-form/${idForm}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // Agrega un campo nuevo (ej. "VP2") de forma atómica en el servidor —
  // calcula el código y lo empuja en una sola operación, sin pisar el
  // documento entero con la copia local (ver addField en el controlador).
  async addField(accessToken, idForm, fieldData) {
    try {
      const url = `${this.baseApi}/add-form-field/${idForm}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(fieldData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // Actualiza el 'active' de campos existentes (o los agrega si son nuevos)
  // por 'name', de forma atómica en el servidor — ver updateFieldsActive en
  // el controlador.
  async updateFieldsActive(accessToken, idForm, changes) {
    try {
      const url = `${this.baseApi}/update-form-fields-active/${idForm}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ changes }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // Genérico: actualiza cualquier atributo de campos existentes por 'name'
  // (o los agrega si son nuevos), de forma atómica — ver updateFormFields en
  // el controlador.
  async updateFormFields(accessToken, idForm, changes) {
    try {
      const url = `${this.baseApi}/update-form-fields/${idForm}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ changes }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // Agrega/actualiza indicadores (por 'name') de forma atómica, creando el
  // formulario si no existe — ver upsertFormIndicators en el controlador.
  async upsertFormIndicators(accessToken, module, site, data) {
    try {
      const url = `${this.baseApi}/upsert-form-indicators/${module}/${site}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // Agrega una entrada al array 'baseline' (VFS/VPS por año) de forma
  // atómica, creando el formulario si no existe — ver addFormBaseline en el
  // controlador.
  async addFormBaseline(accessToken, module, site, data) {
    try {
      const url = `${this.baseApi}/add-form-baseline/${module}/${site}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteForm(accessToken, idForm) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${this.baseApi}/delete-form/${idForm}`;
      const params = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getFormsBySite(accessToken, site, name, active = undefined) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const url = `${this.baseApi}/forms-site/${site}/${name}?active=${active}`;
      const params = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getFormsByCompany(accessToken, company, name, active = undefined) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      const url = `${this.baseApi}/forms-company/${company}/${name}?active=${active}`;
      const params = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getBaselineByFormBySite(accessToken, site, name, year) {
    const url = `${this.baseApi}/forms-baseline-site/${site}/${name}?year=${year}`;
    const params = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const response = await fetch(url, params);

    if (!response.ok) {
      if (response.status === 503 || response.status === 504) {
        const err = new Error(`${response.status} Service Unavailable`);
        err.status = response.status;
        throw err;
      }
      let errBody;
      try {
        errBody = await response.json();
      } catch {
        errBody = { code: response.status };
      }
      throw errBody;
    }

    return response.json();
  }

  async getLastBaselineByFormBySite(accessToken, site, name, year) {
    const url = year != null
      ? `${this.baseApi}/forms-last-baseline-site/${site}/${name}?year=${year}`
      : `${this.baseApi}/forms-last-baseline-site/${site}/${name}`;
    const params = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const response = await fetch(url, params);
    if (!response.ok) {
      if (response.status === 503) {
        const err = new Error("503 Service Unavailable");
        err.status = 503;
        throw err;
      }
      // Non-503 (e.g. 500: site has no baseline data) — return safe empty
      try {
        return await response.json();
      } catch {
        return { baseline: null };
      }
    }
    return response.json();
  }
}
